export default __webpack_public_path__ + "static/media/p19.e8782167.jpg";